module.exports = __webpack_public_path__ + "img/loong-large.5f7594f8.jpg";